module.exports = __webpack_public_path__ + "static/img/Bachelor_010541.8e61487.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010541.jpg
// module id = 185
// module chunks = 0